// Module
var code = "<div class=\"col-sm-12\" cg-busy=\"$ctrl.loadingGridData\"> <div class=\"row\"> <div class=\"dtp-ui-grid margin-top-10\"> <div id=\"grid-productOwnerAssignments\" ag-grid=\"$ctrl.gridOptions\" class=\"ag-theme-balham\"></div> </div> </div> </div>";
// Exports
module.exports = code;